module.exports = __webpack_public_path__ + "img/DE02362.78a514e6.png";